export const convertForReader = (id) => {
  const str = `${id}`;

  if (str.length >= 4) {
    return str;
  }

  const resultArr = [];
  const arr = str.split("").reverse();

  for (let i = 0; i < 4; i++) {
    if (arr[i]) {
      resultArr.push(arr[i]);
    } else {
      resultArr.push("0");
    }
  }

  return resultArr.reverse().join("");
};

export const convertToNormal = (str) => {
  return +str;
};
